import React, { useState } from "react";
import Main from "./components/Main";
import { ToastProvider } from 'react-toast-notifications';
import { useIdleTimer } from 'react-idle-timer'
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { dataUsuario } from "./redux/actions/aLogin";
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';


const App = () => {

  const dispatch = useDispatch();

  const usuario = useSelector(state => state.datosUsuarios.dataUsuario)

  const [chatActivo, setChatActivo] = useState(process.env.REACT_APP_ENABLE_CHAT == 'true' ? true : false)
  const [propertyId, setPropertyId] = useState(process.env.REACT_APP_TAWK_PROPERTY_ID)
  const [widgetId, setWidgetId] = useState(process.env.REACT_APP_TAWK_WIDGET_ID) 



  /**
   * 
   * @param {*} event 
   */
  const handleOnAction = event => {

    if (usuario.userIsLoggedIn) {

      const usuarioEditado = { ...usuario, fechaUltimoAcceso: moment(new Date()).format("DD-MM-YYYY HH:mm:ss") }


      dispatch(dataUsuario(usuarioEditado));
    }

  }

  useIdleTimer({
    timeout: 1000 * 60 * 15,
    onAction: handleOnAction,
    debounce: 500
  })


  return (
    <ToastProvider
      autoDismiss
      autoDismissTimeout={6000}
    // components={{ Toast: Snack }}
    //placement="top-rigth"
    >
      <Main />;

      {chatActivo &&

        <TawkMessengerReact
          propertyId={propertyId}
          widgetId={widgetId} />

      }



    </ToastProvider>
  )
}



export default App;
